import styled from "styled-components";

import { CounterMinusAltIcon, CounterPlusAltIcon } from "assets";

export const Counter = ({
  value,
  maxValue,
  minValue,
  clickCallback,
  disabled,
}: {
  value: number;
  maxValue: number;
  minValue: number;
  clickCallback: (v: number) => void;
  disabled?: boolean;
}) => {
  return (
    <Root $disabled={disabled}>
      <RightBorder>
        <ButtonWrapper
          onClick={e => {
            e.stopPropagation();
            if (disabled) return;
            if (value > minValue) {
              clickCallback(value - 1);
            }
          }}
          disabled={disabled || value <= minValue}
        >
          <CounterMinusAltIcon style={{ width: 16, height: 16 }} />
        </ButtonWrapper>
      </RightBorder>
      <Text $disabled={disabled}>{`${value}/${maxValue}`} </Text>
      <LeftBorder>
        <ButtonWrapper
          onClick={e => {
            e.stopPropagation();
            if (disabled) return;
            if (value < maxValue) {
              clickCallback(value + 1);
            }
          }}
          disabled={disabled || value >= maxValue}
        >
          <CounterPlusAltIcon style={{ width: 16, height: 16 }} />
        </ButtonWrapper>
      </LeftBorder>
    </Root>
  );
};

const ButtonWrapper = styled.button`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  outline: none;
  border: 0;
  padding: 12px 16px;
  transition: background 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.redesign.db5};
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
    background: transparent;
  }

  border-radius: 8px;
`;

const Text = styled.div<{ $disabled?: boolean }>`
  padding: 12px 16px;
  flex-grow: 1;
  text-align: center;
  opacity: ${({ $disabled }) => ($disabled ? 0.8 : 1)};
  font-size: 14px;
`;

const LeftBorder = styled.div`
  border-left: 1px solid ${props => props.theme.colors.greys.concrete};
`;

const RightBorder = styled.div`
  border-right: 1px solid ${props => props.theme.colors.greys.concrete};
`;

const Root = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme, $disabled }) => ($disabled ? theme.colors.greys.silver : theme.colors.greys.concrete)};
  border-radius: 8px;
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
`;
